export default __webpack_public_path__ + "static/media/mentoria-medway.31b07105.svg";